import useAuthenticatedQuery from '@/hooks/useAuthenticatedQuery';
import { useWhoAmIQuery, WhoAmIQuery } from '@/lib/graphql';
import { WatchQueryFetchPolicy } from '@apollo/client';

/**
 * Wraps the whoAmI query and recomposes the data into a `user` and `program` object
 * response, for easier consumption. Uses the Apollo cache.
 */
const useWhoAmI = ({
  fetchPolicy = 'cache-first',
  onCompleted,
}: {
  fetchPolicy?: WatchQueryFetchPolicy;
  onCompleted?: (data: WhoAmIQuery) => void;
} = {}) => {
  const { data, loading, error, refetch } = useAuthenticatedQuery(
    useWhoAmIQuery,
    {
      fetchPolicy: fetchPolicy,
      notifyOnNetworkStatusChange: true,
      onCompleted,
    }
  );

  const user = data?.whoAmI;

  return {
    user,
    isLoading: loading,
    error,
    refetch,
  };
};

export default useWhoAmI;
